import {
  BoltRounded as BoltRoundedIcon,
  LocalFireDepartment as LocalFireDepartmentRoundedIcon,
  WaterDropRounded as WaterDropRoundedIcon,
} from '@mui/icons-material';
import { Tooltip } from '@opendoor/mosaic';
import moment from 'moment';

import { SearchWorkOrderIndex_indextrious_searchTradePartnerWorkOrderIndex_results_utilities as Utility } from '../../../graphql/athena/types/SearchWorkOrderIndex';

const utilityKindToIconMap: { [key: string]: JSX.Element } = {
  gas: <LocalFireDepartmentRoundedIcon fontSize="small" />,
  water: <WaterDropRoundedIcon fontSize="small" />,
  electricity: <BoltRoundedIcon fontSize="small" />,
};

interface Props {
  utilities: Utility[];
}

const Utilities = (props: Props) => {
  const getUtilityColor = (utility: Utility): string => {
    if (!utility || utility.deactivated || !utility.activationDate) return 'red50';
    else if (utility.currentlyActive) return 'green50';
    return 'yellow50';
  };

  const getUtilityTooltipTitle = (utility: Utility): string => {
    let utilityKindCapitalized = utility.kind[0].toUpperCase() + utility.kind.slice(1);
    if (!utility || utility.deactivated || !utility.activationDate)
      return `${utilityKindCapitalized} off`;
    else if (utility.currentlyActive) return `${utilityKindCapitalized} on`;
    return `${utilityKindCapitalized} scheduled for ${moment(utility.activationDate).format(
      'MMM Do',
    )}`;
  };

  return (
    <div className="flex">
      {props.utilities
        .filter(
          (utility: Utility) =>
            utilityKindToIconMap.hasOwnProperty(utility.kind) && !utility.notApplicable,
        )
        .map((utility: Utility) => {
          const utilityColor = getUtilityColor(utility);
          const utilityTooltipTitle = getUtilityTooltipTitle(utility);
          return (
            <Tooltip
              title={utilityTooltipTitle}
              aria-label="utility"
              placement="top"
              key={utility.id}
            >
              <div
                className={`mh-1 pa-1 bo-solid bo-radius-circle flex items-center ${utilityColor}`}
              >
                {utilityKindToIconMap[utility.kind]}
              </div>
            </Tooltip>
          );
        })}
    </div>
  );
};

export default Utilities;
